import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'image'
})
export class ImagePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  public transform(url: string): Observable<SafeUrl> {
    return this.http
      .get(url, {
        headers: { Accept: 'image/jpeg', 'Content-Type': 'image/*', omitLoader: 'true' },
        responseType: 'blob'
      })
      .pipe(
        map(blob => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob))),
        catchError(() => of(''))
      );
  }
}
